<template>
  <div>
    <div class="card">
      <h1>Registrar accesos para Portal</h1>
      <div class="card-body">
        <a-form :form="form" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Concesionario">
                <v-select label="name" :options="getConcesionarios" v-model="$v.user.concesionario.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <small  class="text-danger" v-if="!$v.user.concesionario.required">Campo requerido. No debe estar vacío.</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Correo electrónico">
                <a-input placeholder="Correo electrónico" v-model="$v.user.email.$model"/>
                <small class="text-danger" v-if="!$v.user.email.required">Campo requerido. No debe estar vacío.</small>
                <small class="text-danger" v-if="!$v.user.email.email">El correo electrónico no es válido, no debe contener espacios. Vuelve a intentarlo.</small>
                <small class="text-danger" v-if="!this.validateRegisteredEmail($v.user.email.$model)">Este correo electrónico ya ha sido registrado previamente. Intenta con uno diferente.</small>
              </a-form-item>
            </div>
            <div class="col-md-12">
              <a-form-item>
                <button
                  :disabled="disabledSubmit()"
                  type="button"
                  class="btn btn-light px-5"
                  @click="handleSubmit()"
                >
                  Registrar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import { required, helpers } from 'vuelidate/lib/validators'
// import { encrypt } from '@/config/headers'
import headers from '@/config/headers.js'
const email = helpers.regex('email', /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/)
const ADD_USER_CONCESIONARIO = gql`
  mutation createUserConcesionario($email: String, $concesionarioId: Int){
    createUserConcesionario(userConcesionario: { email: $email, concesionarioId: $concesionarioId }){
      id
      email
      active
      concesionarioId
      cognitoUsername
      createdAt
      updatedAt
    }
  }
`
const GET_CONCESIONARIOS = gql`
  query getConcesionarios{
    getConcesionarios{
      id
      name
      email
      phoneNumber
      rfc
      active
    }
  }
`
const GET_CONCESIONARIO_USERS = gql`
  query getConcesionarioUsers{
    getConcesionarioUsers{
      id
      email
    }
  }
`
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      user: {
        concesionario: null,
        email: '',
      },
      getConcesionarios: [],
      getConcesionarioUsers: [],
    }
  },
  apollo: {
    getConcesionarios: {
      query: GET_CONCESIONARIOS,
      result({ data }) {
        // console.log(data)
      },
      context: headers(),
    },
    getConcesionarioUsers: {
      query: GET_CONCESIONARIO_USERS,
      result({ data }) {
        this.getConcesionarioUsers = this.getConcesionarioUsers.reduce((map, item) => {
          map[item.email] = 1
          return map
        }, {})
        // console.log(this.getConcesionarioUsers)
      },
      context: headers(),
    },
  },
  methods: {
    disabledSubmit() {
      return !(!this.$v.$invalid && this.validateRegisteredEmail(this.$v.user.email.$model))
    },
    validateRegisteredEmail(email) {
      if (this.getConcesionarioUsers[email.trim()]) {
        return false
      } else {
        return true
      }
    },
    handleSubmit() {
      this.$apollo.mutate({
        mutation: ADD_USER_CONCESIONARIO,
        variables: {
          email: this.user.email.trim(),
          concesionarioId: this.user.concesionario.id,
        },
        context: headers(),
      }).then(({ data }) => {
        console.log(data.createUserConcesionario)
        if (data.createUserConcesionario === null) {
          this.makeToast(true, 'danger', 'Error', 'Ya existe un acceso para este concesionario')
        } else {
          this.$router.push('/portal/usuarios')
        }
      }).catch(error => {
        console.log(error)
      })
    },
    makeToast(append = false, variant, title, message) {
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 2000,
        appendToast: append,
        variant: variant,
      })
    },
  },
  validations: {
    user: {
      concesionario: { required },
      email: { required, email },
    },
  },
}
</script>
<style scoped>
</style>
